"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loudspeaker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _i18n = _interopRequireDefault(require("../i18n/i18n"));

var _customizrclient = require("../clients/customizrclient");

var _AnnouncementsList = require("./internal/AnnouncementsList");

var _reactSvg = require("react-svg");

var _loudbot = _interopRequireDefault(require("../assets/loudbot.svg"));

var _definitions = require("./model/definitions");

var _useAnnouncements = require("../hooks/useAnnouncements");

var _i18n2 = require("../hooks/i18n");

var _consts = require("../consts");

var _cimpressComponents = require("../peer/cimpressComponents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const defaultProps = {
  showIcon: false,
  showInlineFeedback: false,
  showManageSubscriptionsButton: true,
  showTopics: false,
  forceShow: undefined
};

const Loudspeaker = ({
  accessToken,
  channelIds,
  title,
  language,
  forceShow,
  announcements,
  showIcon,
  showManageSubscriptionsButton,
  showInlineFeedback,
  showTopics,
  onDismissAnnouncements,
  onRequestHide,
  environment
}) => {
  const loudspeakerEnv = environment || _definitions.ServiceEnvironment.Production;
  const {
    isVisible,
    remoteAnnouncements
  } = (0, _useAnnouncements.useAnnouncements)(accessToken, channelIds, loudspeakerEnv);
  const [showModal, setShowModal] = (0, _react.useState)(isVisible);
  const {
    tt
  } = (0, _i18n2.useDoubleTTranslation)(language);
  const baseUiUrl = loudspeakerEnv === _definitions.ServiceEnvironment.Production ? _consts.LOUDSPEAKER_UI_PRODUCTION : _consts.LOUDSPEAKER_UI_STAGING;
  (0, _react.useEffect)(() => {
    _i18n.default.changeLanguage(language);
  }, [language]);
  (0, _react.useEffect)(() => {
    if (isVisible) {
      setShowModal(true);
    }
  }, [isVisible]);

  const onManageSubscriptions = () => {
    window.open(`${baseUiUrl}/subscriptions`, '_blank');
  };

  const dismissAnnouncements = () => {
    const customizrClient = new _customizrclient.CustomizrClient({
      accessToken,
      channelIds
    });
    customizrClient.acknowledgeAnnouncements(new Date().toISOString());
    closeModal();

    if (onDismissAnnouncements) {
      onDismissAnnouncements();
    }
  };

  const onRemind = () => {
    closeModal();
  };

  const closeModal = () => {
    setShowModal(false);

    if (onRequestHide) {
      onRequestHide();
    }
  };

  let announcementList;

  if (announcements) {
    announcementList = announcements;
  } else {
    announcementList = remoteAnnouncements;
  }

  const unreadAnnouncementsCount = remoteAnnouncements.length;

  const footer = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, showManageSubscriptionsButton ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-child"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, _extends({}, _cimpressComponents.linkButtonProps, {
    size: 'sm',
    onClick: onManageSubscriptions
  }), tt('subscriptionHubLinkText'))) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-child-grow"
  }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-child"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Button, {
    onClick: onRemind
  }, tt('remindText')), /*#__PURE__*/_react.default.createElement(_reactComponents.Button, _extends({}, _cimpressComponents.primaryButtonProps, {
    onClick: dismissAnnouncements
  }), tt('dismissText'))));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Modal, {
    className: "loudspeakerModal",
    show: forceShow === false || forceShow === true ? forceShow : showModal,
    onRequestHide: dismissAnnouncements,
    footer: footer,
    closeButton: true,
    title: title,
    closeOnOutsideClick: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'loudspeakerLoudbot'
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _loudbot.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "loudspeaker"
  }, /*#__PURE__*/_react.default.createElement(_AnnouncementsList.AnnouncementsList, {
    accessToken: accessToken,
    announcements: announcementList,
    showInlineFeedback: showInlineFeedback,
    showTopics: showTopics,
    language: language,
    loudspeakerEnv: loudspeakerEnv
  }))), showIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: "loudspeakerIcon"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Notifications, {
    notifications: [],
    numberUnread: unreadAnnouncementsCount,
    onOpen: () => {
      setShowModal(true);
    },
    showNotificationsOnClick: false
  })) : null);
};

exports.Loudspeaker = Loudspeaker;
Loudspeaker.defaultProps = defaultProps;